import { UTM_PARAMS } from '../actions/types';

const defaultState = {};

/* eslint-disable import/prefer-default-export */
export const utmParamsReducer = (state = defaultState, action) => {
    if (action.type === UTM_PARAMS) {
        return action.payload;
    }

    return state;
};
/* eslint-enable import/prefer-default-export */



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/utm-params.js
 **/